import { render, staticRenderFns } from "./RouteFile.vue?vue&type=template&id=1c140433"
import script from "./RouteFile.vue?vue&type=script&lang=js"
export * from "./RouteFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports